import MiReservaPage from './components/MiReservaPage';

export default MiReservaPage;